import { useEffect, useState } from 'react';
import { getLocalStorage, setLocalStorage } from '../helpers/timeLocalStorage';

// Hook
export function useLocalStorage<T>(key: string, initialValue: T | (() => T)) {
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = useState<T>(() => {
        const value = initialValue instanceof Function ? initialValue() : initialValue;
        try {
            // Get from local storage by key
            const item = getLocalStorage<T>(key, true);
            if (item !== null) {
                return item;
            }
            setLocalStorage(key, value, true);
            return value;
        } catch (error) {
            // report localStorage error and use initial value
            console.error(error);
            return value;
        }
    });

    useEffect(() => {
        setLocalStorage(key, storedValue, true);
    }, [key, storedValue]);

    return [storedValue, setStoredValue] as const;
}
